import React from 'react'

const faqs = [
  {
    id: 1,
    answer:
      "CRM software can give agents a comprehensive view of a customer's history and current status, allowing them to provide more personalised service.",
    question: "Crm Integration",
  },
  {
    id: 2,
    answer:
      "ACD software can direct incoming calls to agents based on predefined standards like call type, agent skills, or other variables.",
    question: "Automatic Call Distribution (acd)",
  },
  {
    id: 3,
    answer:
      "The Outbound Call Center must follow Do Not Call (DNC) regulations and keep a list of Phone Numbers that should not be called.",
    question: "Compliance With Do Not Call (dnc) Regulations",
  },
  {
    id: 4,
    answer:
      "For quality assurance purposes, calls can be recorded, and supervisors can listen in on calls to provide coaching and support.",
    question: "Call Recording And Monitoring",
  },
  {
    id: 4,
    answer:
      "To track call volumes, agent productivity, and other metrics and improve Call Center operations, managers can use reporting and analytics tools.",
    question: "Reporting And Analytics",
  },
  {
    id: 4,
    answer:
      "With various call scripts, agent pools, and call prioritisation rules, Outbound Call Centers may manage several campaigns simultaneously.",
    question: "Campaign Management",
  },
  // More questions...
];

function OutboundSolution() {
  return (
    <div className="bg-white py-2">
      <div className="flex flex-col md:flex-row items-center justify-between p-6 ">
        {/* Left Content */}
        <div className="md:w-1/2 p-4">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            Driving Results Through Outbound Call Centers
          </h1>
          <ul className="list-disc list-inside text-gray-600 space-y-2">
            <p className="text-lg text-gray-600">
              An Outbound Call Center is a variant of a Call Center that manages
              Incoming Calls from customers or clients. Representatives in an
              Outbound Call Center reach out to customers for various purposes,
              including sales, marketing, follow-ups on customer service,
              surveys, and other Outbound Calls. An Outbound Call Center
              constitutes a distinct customer care facility that focuses on
              initiating outgoing calls to clients. The primary goal of an
              Outbound Call Center is to engage with new or existing consumers
              and provide them with valuable information or offers to enrich
              their shopping or customer service interactions. These
              conversations serve multiple functions, including sales and
              marketing, lead generation, customer retention, and market
              research.
            </p>
          </ul>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2 p-4">
          <img
            src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1344&h=1104&q=80"
            alt="Placeholder"
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>

      {/* section */}

      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8">
          <h2 className="text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
            An Outbound Call center May Have The Following Features
          </h2>
          {/* <p className="mt-6 max-w-2xl text-base/7 text-gray-600">
            Solutions for Outbound contact centers offer efficient ways to
            connect with potential consumers, boost revenue and brand exposure,
            and enhance customer engagement.
          </p> */}
          <div className="mt-20">
            <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-16 sm:space-y-0 lg:gap-x-10">
              {faqs.map((faq) => (
                <div key={faq.id}>
                  <dt className="text-base/7 font-semibold text-gray-900">
                    {faq.question}
                  </dt>
                  <dd className="mt-2 text-base/7 text-gray-600">
                    {faq.answer}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>

      {/* section */}
      <div className="flex flex-col md:flex-row items-center justify-between p-6 ">
        {/* Left Content */}
        <div className="md:w-1/2 p-4">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            What Makes Knotnetworks Your Best Choice
          </h1>
          <ul className="list-disc list-inside text-gray-600 space-y-6">
            <li>
              contacting potential customers and convincing them to make a
              purchase or sign up for a service.
            </li>
            <li>
              identifying potential clients and obtaining their contact
              information can assist in generating leads.
            </li>
            <li>
              We are contacting consumers and addressing any difficulties or
              concerns they may have to help retain clients.
            </li>
            <li>
              Obtain feedback on goods or services, which can assist businesses
              in enhancing their offers and patrons' experiences.
            </li>
            <li>
              Businesses connect with many clients at a reduced cost per
              contact.
            </li>
            <li>
              Provide flexibility in call schedule and frequency, enabling
              businesses to customise their outreach initiatives to various
              client segments or marketing campaigns.
            </li>
          </ul>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2 p-4">
          <img
            src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1344&h=1104&q=80"
            alt="Placeholder"
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  );
}

export default OutboundSolution